import React, { Fragment, createElement } from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
// Set title immediately before React mounts
document.title = 'Megapack Estimulación Temprana — Construye Progreso™';
// LCP image — Cloudinary URL with auto format (avif/webp) + auto quality + sized to 400px.
// Reduces image size by ~60% vs the un-transformed URL.
const HERO_IMG = 'https://res.cloudinary.com/dowzlbqlz/image/upload/f_auto,q_auto,w_400/v1777947518/hf_20260505_021521_8449f97b-f5da-48cc-920a-25564eca795d-Photoroom_fekoru.webp';
// Build all <head> resource hints in one go to avoid forced reflow
const frag = document.createDocumentFragment();
// Preconnect ONLY to the LCP image origin (Lighthouse warns when >4 preconnects)
const preconnect = document.createElement('link');
preconnect.rel = 'preconnect';
preconnect.href = 'https://res.cloudinary.com';
preconnect.crossOrigin = 'anonymous';
frag.appendChild(preconnect);
// Preload hero image — MUST match the actual <img src> exactly
const preloadImg = document.createElement('link');
preloadImg.rel = 'preload';
preloadImg.as = 'image';
preloadImg.href = HERO_IMG;
preloadImg.setAttribute('fetchpriority', 'high');
frag.appendChild(preloadImg);
document.head.appendChild(frag);
(window as any).__HERO_IMG__ = HERO_IMG;
render(<App data-id="element-375" />, document.getElementById('root'));